module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buyingPrice":"Buying price"},"fr":{"buyingPrice":"Prix d\u0027achat"},"de":{"buyingPrice":"Kaufpreis"}}')
  delete Component.options._Ctor
}
